import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify);

export default new Vuetify({
  iconfont: 'md',
  theme:{
    themes:{
        light:{
             danetest: '#eebf00'
        }
    }
}
});
